
import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import { ClientAvatarShow } from '../components/ClientAvatarShow';
import { ClientAvatarUpload } from '../components/ClientAvatarUpload';

export function ClientAvatar() {
    return (
        <Grid 
            container 
            direction="column" 
            spacing={3}>
            <Grid item xs={12}>
                <Typography variant="subtitle1">
                Avatar
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid 
                    container 
                    direction="column" 
                    justify="center" 
                    alignItems="center"
                    spacing={1}>
                    <Grid item><ClientAvatarShow /></Grid>
                    <Grid item><ClientAvatarUpload /></Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}